export function TrendIndicator({
  value,
  formatter,
  reverse,
  variant = 'default'
}: {
  value: number
  formatter?: (value: number) => string
  reverse?: boolean
  variant?: 'default' | 'small'
}) {
  if (value === 0) return null

  // const trendArrow = value > 0 ? (reverse ? '↓' : '↑') : reverse ? '↑' : '↓'
  const trendArrow = '↑'

  return (
    <div
      className={`text-sm font-bold flex items-center ${variant === 'small' ? 'text-xs' : 'text-sm'} ${
        value > 0 ? (reverse ? 'text-red-500' : 'text-primary-dark') : reverse ? 'text-primary-dark' : 'text-red-500'
      }`}
    >
      <div
        className='text-sm font-bold inline-block'
        style={{
          transform: `rotate(${value > 0 ? 45 : 135}deg)`
        }}
      >
        {trendArrow}
      </div>{' '}
      <span>{formatter ? formatter(value) : value}</span>
    </div>
  )
}
